export const FILE_SIZE_LIMIT_IN_BYTES = 5000000;
export const IMAGE_SIZE_LIMIT_IN_BYTES = 2000000;
export const SUPPORTED_FILE_FORMATS = ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png'];
export const SUPPORTED_IMAGE_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
